// THIS IS ONLY FOR CRITEO.  IT'S GTM STUFF SHOULD USE THE NEW ADVANCED EVENTS INSTEAD OF THIS STUFF

export function wireCriteoEvents(app) {
    app.$uiEvents.$on('productViewed', emitProductViewed)
    app.$uiEvents.$on('productLineViewed', emitProductLineViewed)
    app.$uiEvents.$on('productListViewed', emitProductListViewed)
    app.$uiEvents.$on('firstLoaded', emitCartPageViewed)
    app.$uiEvents.$on('routeChanged', emitCartPageViewed)

    function emitProductViewed({ location }) {
        if (location !== 'main' || !app.store.state.product) return // don't care about real-time drills or groups (only plines)

        window.dataLayer.push({
            event: 'custom.gtm.productLineViewed',
            'custom.gtm.productLineViewedData': {
                productLineSlug: app.store.state.product.productLineSlug,
            },
        })
    }

    function emitProductLineViewed() {
        if (!app.store.state.product) return

        // app.store.state.product.data -- for real data later
        window.dataLayer.push({
            event: 'custom.gtm.productLineViewed',
            'custom.gtm.productLineViewedData': {
                productLineSlug: app.store.state.product.productLineSlug, // really should come from the pline Api back to us
            },
        })
    }

    // since Algolia doesn't have it's data in vuex, we have to get it passed to us
    function emitProductListViewed({ results }) {
        if (!results) return

        const products = results.map((result) => {
            return {
                productLineSlug: result.productLineSlug,
                // skuSlug: result.skuSlug,
            }
        })

        window.dataLayer.push({
            event: 'custom.gtm.productListViewed',
            'custom.gtm.productListViewedData': {
                location,
                products,
            },
        })
    }

    function emitCartPageViewed({ to }) {
        if (
            to.name !== 'cart' ||
            !app.store.state.cart.data ||
            !app.store.state.cart.data.items ||
            app.store.state.cart.data.items.length === 0
        )
            return

        const products = app.store.state.cart.data.items.map((product) => {
            return {
                productLineSlug: product.productLineSlug,
                quantity: product.qty,
                salePriceCents: product.salePrice,
            }
        })

        window.dataLayer.push({
            event: 'custom.gtm.cartPageViewed',
            'custom.gtm.cartData': {
                products,
            },
        })
    }
}
